import { DollarSign, Wrench, FileX2, Clock4, HeartHandshake, Users } from "lucide-react";

const BENEFITS = [
  {
    icon: DollarSign,
    title: "All Cash, No Surprises",
    body: "Our offers are backed by real money — not contingencies, banks, or loan approvals.",
  },
  {
    icon: Wrench,
    title: "As-Is Condition",
    body: "Don't lift a finger. Old roof, foundation, code violations, hoarder homes — we buy it.",
  },
  {
    icon: FileX2,
    title: "No Fees, No Commissions",
    body: "Skip the 6% agent commission. We even cover standard closing costs.",
  },
  {
    icon: Clock4,
    title: "Close on Your Timeline",
    body: "3 weeks or 3 months — you pick the closing date. Need to stay a bit longer? Talk to us.",
  },
  {
    icon: HeartHandshake,
    title: "Respectful & Discreet",
    body: "Inherited home, divorce, foreclosure, tired landlord — we treat your story with care.",
  },
  {
    icon: Users,
    title: "Family-Run Business",
    body: "We're not a giant hedge fund. Real people, direct communication, fair deals.",
  },
];

export default function Benefits() {
  return (
    <section
      id="benefits"
      data-testid="benefits-section"
      className="py-20 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 items-end mb-14">
          <div>
            <span className="text-xs uppercase tracking-[0.2em] text-[#D95D39] font-medium">
              Why Choose T&amp;R Capital
            </span>
            <h2 className="mt-3 font-[Outfit] font-semibold text-[#2C3D30] text-3xl sm:text-4xl lg:text-5xl tracking-tight">
              The friendly way to sell a house.
            </h2>
          </div>
          <p className="text-[#5B6B5F] text-base lg:text-lg max-w-lg">
            We built this company because traditional home sales are slow, expensive, and stressful.
            Here&apos;s what we do differently.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {BENEFITS.map((b, idx) => {
            const Icon = b.icon;
            return (
              <div
                key={b.title}
                data-testid={`benefit-${idx}`}
                className="group bg-white rounded-2xl p-7 border border-[#E2DDD7] hover:border-[#D95D39]/40 hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-11 h-11 rounded-xl bg-[#F1EDE7] flex items-center justify-center text-[#D95D39] group-hover:bg-[#D95D39] group-hover:text-white transition-colors">
                  <Icon strokeWidth={1.5} className="w-5 h-5" />
                </div>
                <h3 className="mt-5 font-[Outfit] font-medium text-[#2C3D30] text-lg">{b.title}</h3>
                <p className="mt-2 text-sm text-[#5B6B5F] leading-relaxed">{b.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
